var styleDataHash = '11b0b805';  
export const injectCss = (() => {
  var css = `.LoD3Z{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .LoD3Z{border:0}[dir=ltr] .LoD3Z{left:0}[dir=rtl] .LoD3Z{right:0}.g471b{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .g471b,[dir=rtl] .g471b{left:0;right:0}.Q-I40{height:0;position:relative}[dir] .Q-I40{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.Q-I40{min-width:auto}}}@container (width < 640px){.Q-I40{min-width:auto}}.rHdvh{display:block!important;margin:12px 0}._5Zc4b,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._9wv9V{--ricos-custom-p-font-size:14px;color:var(--ricos-custom-p-color,unset);display:block;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);justify-content:center;line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);padding-inline:16px;text-align:center;text-decoration:var(--ricos-custom-p-text-decoration,unset)}._9wv9V>span>a,._9wv9V>span>span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:640px){._9wv9V{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 640px){._9wv9V{font-size:var(--ricos-custom-p-font-size,unset)}}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





